import React from 'react';
import PageHero from '../components/PageHero';
import FAQAccordion from '../components/FAQAccordion';
import { FAQS } from '../data/faqs';
import { SUPPORT_EMAIL } from '../config';
import usePageMeta from '../hooks/usePageMeta';
import styles from './FAQPage.module.css';

export default function FAQPage() {
  usePageMeta(
    'FAQ — Revive Worship',
    'Answers to the questions we get most: where Revive meets, what to expect, and how to get involved.'
  );

  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title={['FAQs.']}
        lede="A quick rundown of the questions we get most. Don't see yours? Send a note and we'll get back to you."
        image="/images/bible.jpg"
      />

      <section className={styles.faqBlock}>
        <div className={styles.shell}>
          <FAQAccordion items={FAQS} defaultOpen={-1} />

          <div className={styles.askBox}>
            <p>Still curious about something?</p>
            <a className={styles.askBtn} href={`mailto:${SUPPORT_EMAIL}`}>
              Email us at {SUPPORT_EMAIL} <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
